// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Sign/Login/Login.css */


.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 75vh;
    background-color: white;
    border-radius: 10px;
    padding: 2rem;
}

.login-headi {
    color:#EF6F53;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
    letter-spacing: 0.05rem;
    margin-bottom: 1rem;
    margin-top: 1rem;
}

.login-left {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1rem;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.35);
    position: relative;
}

.lockout-timer {
    /* position: absolute;
    top: 0;
    left: 0;
    right: 0; */
    padding: 1px;
    /* background-color: #ff6b6b;
    color: white; */
    background-color: #ececec6e;
    color:#ff6b6b;
    /* /* text-align: center; */
    border-radius: 10px; 
    font-size: 15px;
    font-weight: 600;
    /* animation: pulse 2s infinite; */
}

/* @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.8; }
    100% { opacity: 1; }
} */

.login-left form {
    display: flex;
    flex-direction: column;
    width: 80%;
    margin: auto;
}

.login-left label {
    font-size: 1rem;
    color: #364C63;
    margin-bottom: 0.25rem;
}

.login-left input {
    padding: 0.25rem;
    font-size: 1rem;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin-bottom: 1rem;
    outline: none;
}

.login-left input:focus {
    border-color: #EF6F53;
}

.login-left button {
    background-color: #EF6F53;
    color: white;
    border: none;
    width: 30%;
    margin: auto;
    padding: 0.25rem;
    font-size: 1rem;
    border-radius: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

/* .login-left button:hover {
    background-color: #d15846;
} */

.login-left button:hover:not([disabled]) {
    background-color: #d15846;
    cursor: progress;
}

.regis{
    display: flex;
    margin: auto;
}

.head2 {
    color: #364C63;
    text-align: center;
    font-size: 0.9rem;
    margin-top: 0.75rem;
    margin-right: 0.5rem;
}

.register-link {
    display: inline-block;
    margin-top: 0.5rem;
    color: #EF6F53;
    font-weight: bold;
    text-decoration: none;
}

.register-link:hover {
    text-decoration: underline;
}


.login-right {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.sign-icon {
    width: 80%;
    max-width: 25rem;
    border-radius: 5px;
    margin-left: 30%;
}


.forgot-password-link {
    text-align: center;
    margin-bottom: 10px;
}

.forgot-password-link a {
    color: #007bff;
    text-decoration: none;
    font-weight: bold;
    font-size: 1rem;
}

.forgot-password-link a:hover {
    text-decoration: underline;
}


/* Responsive Design */
@media (max-width: 768px) {

    .login-container {
        flex-direction: column-reverse;
        height: auto;
    }

    .login-left{
        width: 50%;
        margin: auto;
    }

    .login-right{
        width: 50%;
        margin: auto;
    }

    .sign-icon{
        margin: auto;
        margin-top: 1rem;

    }

}`, "",{"version":3,"sources":["webpack://./src/components/routes/Sign/Login/Login.css"],"names":[],"mappings":"AAAA,+CAA+C;;;AAG/C;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI;;;eAGW;IACX,YAAY;IACZ;mBACe;IACf,2BAA2B;IAC3B,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;;;;GAIG;;AAEH;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;;GAEG;;AAEH;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA,sBAAsB;AACtB;;IAEI;QACI,8BAA8B;QAC9B,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,gBAAgB;;IAEpB;;AAEJ","sourcesContent":["/* src/components/routes/Sign/Login/Login.css */\n\n\n.login-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 75vh;\n    background-color: white;\n    border-radius: 10px;\n    padding: 2rem;\n}\n\n.login-headi {\n    color:#EF6F53;\n    text-align: center;\n    font-size: 1.5rem;\n    font-weight: bold;\n    letter-spacing: 0.05rem;\n    margin-bottom: 1rem;\n    margin-top: 1rem;\n}\n\n.login-left {\n    width: 30%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 1rem;\n    background-color: white;\n    border-radius: 10px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.35);\n    position: relative;\n}\n\n.lockout-timer {\n    /* position: absolute;\n    top: 0;\n    left: 0;\n    right: 0; */\n    padding: 1px;\n    /* background-color: #ff6b6b;\n    color: white; */\n    background-color: #ececec6e;\n    color:#ff6b6b;\n    /* /* text-align: center; */\n    border-radius: 10px; \n    font-size: 15px;\n    font-weight: 600;\n    /* animation: pulse 2s infinite; */\n}\n\n/* @keyframes pulse {\n    0% { opacity: 1; }\n    50% { opacity: 0.8; }\n    100% { opacity: 1; }\n} */\n\n.login-left form {\n    display: flex;\n    flex-direction: column;\n    width: 80%;\n    margin: auto;\n}\n\n.login-left label {\n    font-size: 1rem;\n    color: #364C63;\n    margin-bottom: 0.25rem;\n}\n\n.login-left input {\n    padding: 0.25rem;\n    font-size: 1rem;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    margin-bottom: 1rem;\n    outline: none;\n}\n\n.login-left input:focus {\n    border-color: #EF6F53;\n}\n\n.login-left button {\n    background-color: #EF6F53;\n    color: white;\n    border: none;\n    width: 30%;\n    margin: auto;\n    padding: 0.25rem;\n    font-size: 1rem;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n/* .login-left button:hover {\n    background-color: #d15846;\n} */\n\n.login-left button:hover:not([disabled]) {\n    background-color: #d15846;\n    cursor: progress;\n}\n\n.regis{\n    display: flex;\n    margin: auto;\n}\n\n.head2 {\n    color: #364C63;\n    text-align: center;\n    font-size: 0.9rem;\n    margin-top: 0.75rem;\n    margin-right: 0.5rem;\n}\n\n.register-link {\n    display: inline-block;\n    margin-top: 0.5rem;\n    color: #EF6F53;\n    font-weight: bold;\n    text-decoration: none;\n}\n\n.register-link:hover {\n    text-decoration: underline;\n}\n\n\n.login-right {\n    width: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.sign-icon {\n    width: 80%;\n    max-width: 25rem;\n    border-radius: 5px;\n    margin-left: 30%;\n}\n\n\n.forgot-password-link {\n    text-align: center;\n    margin-bottom: 10px;\n}\n\n.forgot-password-link a {\n    color: #007bff;\n    text-decoration: none;\n    font-weight: bold;\n    font-size: 1rem;\n}\n\n.forgot-password-link a:hover {\n    text-decoration: underline;\n}\n\n\n/* Responsive Design */\n@media (max-width: 768px) {\n\n    .login-container {\n        flex-direction: column-reverse;\n        height: auto;\n    }\n\n    .login-left{\n        width: 50%;\n        margin: auto;\n    }\n\n    .login-right{\n        width: 50%;\n        margin: auto;\n    }\n\n    .sign-icon{\n        margin: auto;\n        margin-top: 1rem;\n\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
